<div>
    <div class="modal fade" :id="idForModal">
        <div class="modal-dialog modal-lg modal-warning">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Reset User Password - {{username}}</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <!-- Modal body -->
                <div class="modal-body">
                    <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                        {{successMessage}}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                        {{errorMessage}}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="mt-3" v-if="!showSuccessMessage && !showErrorMessage">
                        <h4>Password Generator</h4>
                        <div class="float-right">
                            <button class="btn btn-primary" @click="generatePassword">
                                Generate Password
                            </button>
                        </div>
                        <br>
                        <br>
                        <div>
                            <div class="form-group">
                                <label>Random Password</label>
                                <div class="text-danger" v-if="passwordHasError">
                                    {{passwordErrorMessage}}
                                </div>
                                <input type="text" class="form-control" v-model="password" disabled/>
                            </div>
                        </div>
                        
<!--                        <div class="row">-->
<!--                            <div class="col-8">-->
<!--                                <div class="form-group">-->
<!--                                    <label>Random Password</label>-->
<!--                                    <div class="text-danger" v-if="passwordHasError">-->
<!--                                        {{passwordErrorMessage}}-->
<!--                                    </div>-->
<!--                                    <input type="string" class="form-control" v-model="password" disabled/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-4">-->
<!--                                <div class="mt-3">-->
<!--                                    <button class="btn btn-primary" @click="generatePassword">-->
<!--                                        Generate Password-->
<!--                                    </button>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                        
                        <div class="form-group">
                            <label>Password Length</label>
                            <input type="number" class="form-control" v-model="passwordGenerator.length" @change="onPasswordLengthChange"/>
                        </div>
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="lowercaseCharactersCheckbox" v-model="passwordGenerator.lowercaseCharacters"
                                    @change="onLowercaseLettersForPasswordChange" disabled>
                                <label class="form-check-label" for="lowercaseCharactersCheckbox">
                                  Lowercase Characters (e.g. abcdef)
                                </label>
                              </div>
                        </div>
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="uppercaseCharactersCheckbox" v-model="passwordGenerator.uppercaseCharacters"
                                    @change="onUppercaseLettersForPasswordChange">
                                <label class="form-check-label" for="uppercaseCharactersCheckbox">
                                  Uppercase Characters (e.g. ABCDEF)
                                </label>
                              </div>
                        </div>
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="numbersCharactersCheckbox" v-model="passwordGenerator.numbers"
                                    @change="onNumbersForPasswordChange">
                                <label class="form-check-label" for="numbersCharactersCheckbox">
                                  Numbers (e.g. 123456)
                                </label>
                              </div>
                        </div>
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="symbolsCharactersCheckbox" v-model="passwordGenerator.symbols"
                                    @change="onSymbolsForPasswordChange">
                                <label class="form-check-label" for="symbolsCharactersCheckbox">
                                  Symbols (e.g. *@#+%)
                                </label>
                              </div>
                        </div>
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="excludeSimilarCharactersCheckbox" v-model="passwordGenerator.excludeSimilarCharacters"
                                    @change="onExcludeSimilarCharactersForPasswordChange">
                                <label class="form-check-label" for="excludeSimilarCharactersCheckbox">
                                  Exclude Similar Characters (e.g. o,0,i,l,1)
                                </label>
                              </div>
                        </div>
                        <div class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="excludeAmbiguousCharactersCheckbox" v-model="passwordGenerator.excludeAmbiguousCharacters"
                                    @change="onExcludeAmbiguousCharactersForPasswordChange">
                                <label class="form-check-label" for="excludeAmbiguousCharactersCheckbox">
                                  Exclude Ambiguous Characters (e.g. ~,;:.{}&lt;&gt;[]()/\'`)
                                </label>
                              </div>
                        </div>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="resetUserPassword" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage">Reset Password</button>
                    <button type="button" class="btn btn-secondary" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage" @click="clearMessageAlerts">Cancel</button>
                    <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="clearMessageAlerts">OK</button>
                </div>
            </div>
        </div>
    </div><!-- end of modal -->
</div>
